(function (angular) {
	angular.module('bizPartEngage').directive('bizSimulateUser', bizSimulateUser);
	angular.module('bizPartEngage').service('bizSimulateUserService', bizSimulateUserService);

	bizSimulateUser.$inject = [];
	bizSimulateUserService.$inject = ['$http'];

	function bizSimulateUser() {
		return {
			restrict: 'E',
			templateUrl: siteRootPath + 'FrontEnd/Core/Directives/Views/SimulateUser.html',
			controllerAs: 'vm',
			controller: bizSimulateUserController,
			bindToController: true,
			scope: {
				simulating: '=?',
				isAllowedToSimulate: '=?',
			},
		};
	}

	bizSimulateUserController.$inject = ['$rootScope', '$window', '$filter', 'bizSimulateUserService'];

	function bizSimulateUserController($rootScope, $window, $filter, bizSimulateUserService) {
		var vm = this;

		vm.Init = Init;
		vm.CancelSimulation = CancelSimulation;
		vm.SimulateShadowUser = SimulateShadowUser;

		function CancelSimulation() {
			vm.Preparing = true;
			bizSimulateUserService.CancelSimulation().then(CancelSimulationCallback);

			function CancelSimulationCallback(response) {
				var simulation = response.data;
				// Preserve the persistent auth cookie restored by the backend.
				setBizPartAuthToken(simulation.SimulatedByUserToken, simulation.SimulatedByUserId);
				deleteSessionStorage('SimulateDate');
				$window.location.href = $filter('siteroot')('/');
			}
		}

		function SimulateShadowUser(key) {
			vm.Preparing = true;
			bizSimulateUserService.SimulateShadowUser(key).then(SimulateUserCallback);

			function SimulateUserCallback(response) {
				var userSession = response.data;
				if (!userSession) return;

				setBizPartAuthToken(userSession.Token, userSession.UserId);
				deleteLocalStorage('HasShownWelcomeGuide');
				$window.location.href = $filter('siteroot')('/');
			}
		}

		function Init() {
			if ($rootScope.HasModuleAccess('SHADOW_USER_SIMULATION', '10') || isSimulatingShadowUser) {
				bizSimulateUserService.GetShadowUserSimulationInfo().then(GetShadowUserSimulationInfoCallback);

				function GetShadowUserSimulationInfoCallback(response) {
					vm.ShadowUserSimulationInfo = response.data;
				}
			}
		}

		$rootScope.Initialized.then(vm.Init);
	}

	function bizSimulateUserService($http) {
		return {
			GetShadowUserSimulationInfo: GetShadowUserSimulationInfo,
			SimulateShadowUser: SimulateShadowUser,
			CancelSimulation: CancelSimulation,
		};

		function GetShadowUserSimulationInfo() {
			return $http.get(siteRootPath + 'api/UserSimulation/GetShadowUserSimulationInfo', {});
		}

		function SimulateShadowUser(key) {
			return $http.post(siteRootPath + 'api/UserSimulation/SimulateUser', {
				ShadowUserConfigKey: key,
			});
		}

		function CancelSimulation() {
			return $http.post(siteRootPath + 'api/User/CancelUserSimulation');
		}
	}
})(window.angular);
